import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenService } from '../../services/token.service';
import { RoutePath } from '../enums/route-path.enum';
import { Logger } from '@utils/logger.util';

/**
 * Guard para la ruta de login
 * Si el usuario ya tiene un token válido, lo redirige al backoffice
 * Esto previene que un usuario logueado vea el login y genere confusión con tokens
 */
export const loginGuard: CanActivateFn = (route, state) => {
    const tokenService = inject(TokenService);
    const router = inject(Router);

    const token = tokenService.getToken();
    const isTokenValid = token && !tokenService.isTokenExpired();

    if (isTokenValid) {
        // Si el token es válido, redirigir al backoffice (home según menú del rol)
        Logger.log('Token válido detectado, redirigiendo al backoffice...');
        // El sidenav elige el primer módulo permitido según navigationMenu del rol
        router.navigate([`/${RoutePath.BACKOFFICE}/${RoutePath.HOME}`]);
        return false;
    }

    // Si no hay token o está vencido, permitir acceso al login
    return true;
};

